/** Metadata client-safe para la UI de conectores/asignación (§9.7). Sin secretos. */
export const PROVIDER_LABEL = {
    anthropic: 'Anthropic (Claude)',
    openai: 'OpenAI',
    gemini: 'Google Gemini',
    deepseek: 'DeepSeek',
    glm: 'GLM / Zhipu',
};
export const PROVIDER_DEFAULT_BASE_URL = {
    anthropic: 'https://api.anthropic.com',
    openai: 'https://api.openai.com/v1',
    gemini: 'https://generativelanguage.googleapis.com',
    deepseek: 'https://api.deepseek.com',
    glm: 'https://open.bigmodel.cn/api/paas/v4',
};
/** Modelos sugeridos por proveedor (editable como texto libre en la UI). */
export const SUGGESTED_MODELS = {
    anthropic: ['claude-opus-4-8', 'claude-sonnet-5', 'claude-haiku-4-5-20251001'],
    openai: ['gpt-4o', 'gpt-4o-mini', 'o4-mini'],
    gemini: ['gemini-2.5-pro', 'gemini-2.5-flash', 'gemini-2.5-flash-lite', 'gemini-2.0-flash'],
    deepseek: ['deepseek-chat', 'deepseek-reasoner'],
    glm: ['glm-4-plus', 'glm-4'],
};
/** Rol de cada nodo, para la UI de asignación. */
export const AGENT_LABEL = {
    N1: 'N1 · Extractor',
    N2: 'N2 · Clasificador / Priorizador',
    N3: 'N3 · Redactor',
    N4: 'N4 · Evaluador (QA)',
    N5: 'N5 · Ensamblador',
};
/** Tier recomendado por nodo (advertencia informativa, no bloquea). */
export const RECOMMENDED_TIER = {
    N4: 'QA crítico: usa el modelo más capaz disponible (p. ej. gemini-2.5-pro).',
    N2: 'Clasificación: conviene un modelo capaz para no perder relevancia.',
};
//# sourceMappingURL=llmMeta.js.map